import { FC, useEffect } from "react";

import Layout from "layouts/Layout";
import ErrorBoundary from "common/components/custom/error-boundary";
import useCookie from "common/hooks/useCookie";

const App: FC = () => {
  const { checkCookie } = useCookie();
  useEffect(() => {
    checkCookie();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <ErrorBoundary>
        <Layout />
      </ErrorBoundary>
    </>
  );
};

export default App;
